import Vue from 'vue'

export let EventBus = new Vue()
